/**
 * Persists last successful JSON responses for public GET endpoints so the app
 * can reuse them when offline (same pattern as kioskInfoCache).
 */

const PREFIX = 'offline_api_raw_v1:';

export function writeOfflineApiCache(endpointKey: string, value: unknown): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(PREFIX + endpointKey, JSON.stringify(value));
  } catch {
    /* quota / private mode */
  }
}

export function readOfflineApiCache<T>(endpointKey: string): T | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(PREFIX + endpointKey);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function clearOfflineApiCache(endpointKey: string): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(PREFIX + endpointKey);
  } catch {
    /* ignore */
  }
}

/** Stable keys — match api path segments after /api */
export const OFFLINE_CACHE_KEYS = {
  VFX_CONFIG: 'vfx-config',
  GAME_PROVIDERS: 'game-providers',
} as const;
